import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const DeleteWorkHistoryJobModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "DeleteWorkHistoryJobModalContainer" */
      './DeleteWorkHistoryJobModalContainer'
    ),
  loading: LoadingModal,
});
